import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function Redirects() {
  const qc = useQueryClient();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const { data: redirects } = useQuery({ queryKey: ["cms-redirects"], queryFn: async () => (await api.get("/cms/redirects")).data });

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/cms/redirects", { from_path: from.trim(), to_path: to.trim(), status: 301 });
      setFrom(""); setTo("");
      qc.invalidateQueries({ queryKey: ["cms-redirects"] });
      toast.success("Redirect added");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  const del = async (id) => {
    try { await api.delete(`/cms/redirects/${id}`); qc.invalidateQueries({ queryKey: ["cms-redirects"] }); toast.success("Deleted"); }
    catch { toast.error("Delete failed"); }
  };

  const input = "w-full bg-obsidian border border-white/15 rounded-lg px-3 py-2 text-sm text-ink focus:border-copper";

  return (
    <div>
      <h1 className="text-3xl font-bold uppercase tracking-tight text-ink mb-1">Redirects</h1>
      <p className="text-subtle text-sm mb-6">301 redirects. Loops, chains & self-redirects are blocked automatically.</p>

      <form onSubmit={add} data-testid="redirect-form" className="card-surface !hover:translate-y-0 p-5 grid grid-cols-1 sm:grid-cols-3 gap-3 items-end mb-8">
        <div><label className="block text-xs text-subtle mb-1.5">From (e.g. /tr/eski-slug/)</label><input data-testid="redirect-from" required value={from} onChange={(e) => setFrom(e.target.value)} className={input} /></div>
        <div><label className="block text-xs text-subtle mb-1.5">To (e.g. /tr/yeni-slug/)</label><input data-testid="redirect-to" required value={to} onChange={(e) => setTo(e.target.value)} className={input} /></div>
        <button data-testid="redirect-add" type="submit" className="btn-copper">Add 301</button>
      </form>

      <div className="space-y-2">
        {(redirects || []).map((r) => (
          <div key={r.id} className="card-surface !hover:translate-y-0 p-4 flex items-center justify-between" data-testid={`redirect-${r.id}`}>
            <p className="text-sm text-ink font-mono">{r.from_path} <span className="text-copper">→ {r.status} →</span> {r.to_path}</p>
            <button data-testid={`redirect-del-${r.id}`} onClick={() => del(r.id)} className="text-subtle hover:text-red-400"><Trash2 size={16} /></button>
          </div>
        ))}
        {(redirects || []).length === 0 && <p className="text-faint text-sm">No redirects.</p>}
      </div>
    </div>
  );
}
